/* 主栏目 每个站点不一样 */

const menu = [
  {item: "首页", url: "https://www.51room.com"},
  {item: "伦敦公寓", url: "https://london.51room.com"}
]

export default menu